import { render, staticRenderFns } from "./Internationalization.vue?vue&type=template&id=e62bff32&"
import script from "./Internationalization.vue?vue&type=script&lang=js&"
export * from "./Internationalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports